import React from "react";
import "./FastGamesListPageStyle.scss";
import MainLayout from "../../components/MainLayout";
import BannerSection from "../../components/BannerSection";
import ContactUsSection from "../../components/ContactUsSection";
import AllFastGamesSection from "../../components/AllFastGamesSection";

const FastGamesListPage = () => {
  return (
    <MainLayout>
      <div className="fast-games-page">
        <BannerSection />
        <AllFastGamesSection />
        <ContactUsSection />
      </div>
    </MainLayout>
  );
};

export default FastGamesListPage;
